import { hPost, hGet } from "@osgfe/tools";

const API_MAP = {
  // 获取帐号信息
  ACCOUNT_INFO: "/api/vss/shepherd/account/getBizAccountInfo",
  // 获取供应商信息
  SUPPLIER_INFO: "/api/vss/shepherd/supplier/account/info",
  // 获取菜单列表
  MENU_LIST: "/api/vss/shepherd/supplier/auth/list",
  // 获取账号状态
  MERCHANT_STATE: "/api/vss/shepherd/sqm/merchantsSupplier/getMerchantState",
  // 获取资质凭证
  VSS_PHONE:
    "/api/m/vss/generic/sqm/SupplierCertTService/getAdmittanceNoByVssPhone",
};

/**
 * 供应商平台通用接口【商品供应商+劳动力供应商都会用】
 */
export const getAccountInfo = async ({ commit }) => {
  const res = await hPost(API_MAP.ACCOUNT_INFO, {});
  commit("setAccountInfo", res || {});
};

/**
 * 通过账号获取供应商信息【只要商品供应商会用】
 */
export const getSupplierInfoByBizAccountIdApi = async ({ commit }) => {
  console.log("api called");
  const res = await hGet(API_MAP.SUPPLIER_INFO, {});
  commit("setSupplierInfo", res || {});
};

// 侧边菜单数据
export const getSupplierMenuListApi = async ({ commit }) => {
  const res = await hPost(API_MAP.MENU_LIST, { source: 1 });
  commit("setMenuList", res && res.menuInfoList ? res.menuInfoList : []);
};

/**
 * 获取账号状态 0-草稿 1-待审核 2-审核中 3-审核通过 4-审核不通过 5-已准入 999-当前账号存在供应商信息 -1-代表当前账号不存在招商信息
 */
export const getMerchantStateApi = async ({ commit }) => {
  const res = await hPost(API_MAP.MERCHANT_STATE, {});
  commit("setMerchantState", res || {});
  const { state } = res || {};
  // 0-草稿 1-待审核 2-审核中 3-审核通过 4-审核不通过 5-已准入 999-当前账号存在供应商信息 -1-代表当前账号不存在招商信息
  if (state === -1) {
    // window.location.href = `/supplierRecruitment/introduction.html${window.top.location.search}`;
    window.location.href = `/vss/supplier/serviceNotAvailable.html${window.top.location.search}`;
  } else if (state === 0) {
    // window.location.href = `/supplierRecruitment.html${window.top.location.search}`;
    window.location.href = `/vss/supplier/serviceNotAvailable.html${window.top.location.search}`;
  } else if ([1, 2, 3, 4, 5, 6, 7, 8].includes(state)) {
    // window.location.href = `/supplierRecruitment/status.html${window.top.location.search}`;
    window.location.href = `/vss/supplier/serviceNotAvailable.html${window.top.location.search}`;
  }
};
